import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'

import { useForm } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup"

// Atom 
// import Button, { ButtonCategory } from './../../../../Components/Atoms/Button'

// Mol
import Modal, { ModalSize } from './../../../../Components/Molecules/Modal'
import MTooltipModal from "./../../../../Components/Molecules/Modal/Part/MTooltip"

// Sass
import './../../../../Sass/includes/Components/modules/perfilador.sass'

const Perfilador3Form = React.memo((props) => {
    const {
        onSubmit,
        handleChangeCurrentPage,
        nextPage,
        previousPage,
        activePage,
        questionsAnswers,
        handleChangeAnswerSelected,
        setContenidoSel,
        contenidoSel,
    } = props

    //const [count,setCount] = useState([])

    const schemaForm = yup.object().shape({
        // structure: yup.string(),

    });
    // eslint-disable-next-line
    const { register, handleSubmit } = useForm({
        defaultValues: {
            smartphones: [],
            pcs: [],
            smartTV: [],
            videogames: [],
            devices: [],
            systems: [],
        },
        resolver: yupResolver(schemaForm),
    });

    const modalTooltipRef = useRef()
    const openModalTooltip = () => modalTooltipRef.current.open()

    const handleBack = (e) => {
        console.log('Regresar')
        handleChangeCurrentPage(e, null, previousPage)
    }
    // const handleContinue = () => {
    //     console.log('Continue')
    // }

    const onClickUso = (e) => {
        if(!contenidoSel.find(c => c.desc === 'Uso')){
            const val = {
                desc : 'Uso',
                value: e.target.value
            }
            contenidoSel.push(val)
        } else {
            contenidoSel.find(c => c.desc === 'Uso').value = e.target.value
            setContenidoSel(contenidoSel)
        }
    }
    const onClickUso2 = (e) => {
        const checked = e.target.checked
        console.log("onClickUso2::::", e.target, checked)
        // if(!contenidoSel.find(c => c.desc === 'Uso')){
        //     const val = {
        //         desc : 'Uso',
        //         value: e.target.value
        //     }
        //     contenidoSel.push(val)
        // } else {
        //     contenidoSel.find(c => c.desc === 'Uso').value = e.target.value
        //     setContenidoSel(contenidoSel)
        // }
    }

    const dispositivo = contenidoSel.find(c => c.desc === 'Dispositivos')

    /*const validTotalDispositivo = (e, titulo) => {
        const ask = questionsAnswers[activePage - 1]?.find(q => q.fc_TITULO === titulo)
        const totalAsk = ask.perfiladorRespuestas[0].InputValNum

        const askActual = questionsAnswers[activePage]?.find(q => q.fc_TITULO === titulo)
        let totalActual = 0
        askActual.perfiladorRespuestas.map(p => {
            if(p.checked){
                totalActual++
            }
        })
        
        const checked = e.target.checked
        let disSeleccionado = count.find(c => c.titulo === titulo)
            if(!disSeleccionado){
                const val = {
                    titulo: titulo,
                    value: totalActual
                }
                disSeleccionado = val
                count.push(disSeleccionado)
                setCount(count)
            }
        if(checked){
            if(disSeleccionado.value + 1 <= totalAsk){
                disSeleccionado.value = disSeleccionado.value + 1
                handleChangeAnswerSelected(e)    
            }
        } else {
            disSeleccionado.value = disSeleccionado.value - 1
            handleChangeAnswerSelected(e)
        }
        
    }*/

    function perfilador2Select(answer, ask){
        const total = Math.round(answer?.length / 2)
        const element = [];
        for(let i = 0; i < total; i++){
            const ans1 = answer[i * 2]
            const ans2 = answer[i * 2 + 1]
            element.push(<div className="perfStep3GridEleOptCol" key={uuid()}>
                            <div className="perfStep3GridElefldset">
                                <label className="checkbox">
                                    <input type="checkbox" checked={ans1?.checked && ans1?.checked === true ? true : false} name={ask.fi_PREGUNTA + "_" + ans1.fi_RESPUESTA} value={ans1.fi_RESPUESTA} onChange={(e) => {handleChangeAnswerSelected(e); onClickUso2(e)}} />
                                    <div className="checkmark"></div>
                                    <span>{ans1.fc_TITULO}</span>
                                </label>
                            </div>
                            {
                                ans2 &&
                                <div className="perfStep3GridElefldset">
                                    <label className="checkbox">
                                        <input type="checkbox" checked={ans2?.checked && ans2?.checked === true ? true : false} name={ask.fi_PREGUNTA + "_" + ans2.fi_RESPUESTA} value={ans2.fi_RESPUESTA} onChange={(e) => {handleChangeAnswerSelected(e); onClickUso2(e)}} />
                                        <div className="checkmark"></div>
                                        <span>{ans2.fc_TITULO}</span>
                                    </label>
                                </div>
                            }
                        </div>
                        )
        }
        
        return <>{element}</>;
    }
    const UsoD = contenidoSel.find(c => c.desc === 'UsoD')
    
    // eslint-disable-next-line
    const IsCheckAsk = questionsAnswers[activePage].length ? questionsAnswers[activePage].map((ask, index)=>{
        if(ask?.fi_TIPO === 4 && dispositivo?.showddispositivo?.find( d => d.titulo === ask?.fc_TITULO)){
            if(UsoD?.showddispositivo){
                let checks = UsoD?.showddispositivo.filter(r => r.id_askQ === ask.fi_PREGUNTA)
                if(checks.length){
                    return true
                }else{
                    return false
                }
            }else{
                return false
            }
        }        
    })
    : false 
    console.log("questionsAnswers[activePage]", questionsAnswers[activePage], IsCheckAsk, IsCheckAsk.filter(v => v === false))
    return (
        <>
            <form className="formPerfilador" onSubmit={handleSubmit(onSubmit)}>
                <div className="perfiladorStepsWrap">
                    <h3>¿Qué uso les das a tus dispositivos?</h3>
                    <div className="perfStep3Grid">
                        {
                            questionsAnswers[activePage]?.length
                                ?
                                questionsAnswers[activePage].map((ask, index) => (
                                    ask?.fi_TIPO === 4 && dispositivo?.showddispositivo?.find( d => d.titulo === ask?.fc_TITULO)
                                        ?
                                        <div className="perfStep3GridElement" key={uuid()}>
                                            <a className="mainTooltip" href='#!' onClick={() => openModalTooltip()}>
                                                <i className="ico-alert-circle" />
                                            </a>

                                            <i className={ask.fc_CLASE_ICONO}></i>
                                            <h4>
                                                <strong>{ask.fc_TITULO}</strong>
                                                {
                                                    ask?.fc_DESCRIPCION
                                                        ?
                                                        <span>{ask.fc_DESCRIPCION}</span>
                                                        : null
                                                }
                                            </h4>
                                            {
                                                ask?.perfiladorRespuestas?.length
                                                    ?
                                                    <div className="perfStep3GridEleOpt">
                                                        {
                                                            perfilador2Select(ask?.perfiladorRespuestas, ask)
                                                        }
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>
                                        :
                                            ask?.fi_TIPO === 5 && dispositivo?.showddispositivo?.find( d => d.titulo === ask?.fc_TITULO)
                                            ? 
                                            <div className="perfStep3GridElement">
                                                <div className='perfStep3GridEleSel'>
                                                    <label className="radio">
                                                        <input type="radio" name="opt3" value={ask?.fc_TITULO} onClick={e => onClickUso(e)} />
                                                        <div className="checkmark"></div>
                                                        <span>{ask?.fc_TITULO}</span>
                                                    </label>
                                                </div>
                                                
                                                <div className='perfStep3GridEleList'>
                                                    {
                                                        ask.perfiladorRespuestas.map((answ, index) => (
                                                            <div className='perfStep3GridEleLiItem' key={uuid()}>
                                                                {answ.fc_TITULO}      
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                            : null
                                ))
                                :
                                null
                        }
                        {/* <div className="perfStep3GridElement">
                            <a className="mainTooltip" href='#!' onClick={() => openModalTooltip()}>
                                <i className="ico-alert-circle" />
                            </a>

                            <i className="cIco-smartphones"></i>
                            <h4>
                                <strong>Smartphones y Tablets</strong>
                            </h4>
                            <div className="perfStep3GridEleOpt">
                                <div className="perfStep3GridEleOptCol">
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt1" {...register("smartphones")} value={'nav'} />
                                            <div className="checkmark"></div>
                                            <span>Navegación Web y correo electrónico</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt1" {...register("smartphones")} value={'video'} />
                                            <div className="checkmark"></div>
                                            <span>Videoconferencia y Transmisiones en vivo</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                </div>
                                <div className="perfStep3GridEleOptCol">
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt1" {...register("smartphones")} value={'redes'} />
                                            <div className="checkmark"></div>
                                            <span>Redes Sociales</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt1" {...register("smartphones")} value={'streaming'} />
                                            <div className="checkmark"></div>
                                            <span>Streaming</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                </div>
                                <div className="perfStep3GridEleOptCol">
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt1" {...register("smartphones")} value={'juegos'} />
                                            <div className="checkmark"></div>
                                            <span>Juegos en línea</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt1" {...register("smartphones")} value={'s4k'} />
                                            <div className="checkmark"></div>
                                            <span>Streaming 4K</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="perfStep3GridElement">
                            <a className="mainTooltip" href='#!' onClick={() => openModalTooltip()}>
                                <i className="ico-alert-circle" />
                            </a>
                            <i className="cIco-computadoras"></i>
                            <h4>
                                <strong>Computadoras</strong><span> (escritorio y portátiles)</span>
                            </h4>
                            <div className="perfStep3GridEleOpt">
                                <div className="perfStep3GridEleOptCol">
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt2"  {...register("pcs")} value={'nav'} />
                                            <div className="checkmark"></div>
                                            <span>Navegación Web y correo electrónico</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt2"  {...register("pcs")} value={'video'} />
                                            <div className="checkmark"></div>
                                            <span>Videoconferencia y Transmisiones en vivo</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                </div>
                                <div className="perfStep3GridEleOptCol">
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt2"  {...register("pcs")} value={'redes'} />
                                            <div className="checkmark"></div>
                                            <span>Redes Sociales</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt2"  {...register("pcs")} value={'stream'} />
                                            <div className="checkmark"></div>
                                            <span>Streaming</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                </div>
                                <div className="perfStep3GridEleOptCol">
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt2"  {...register("pcs")} value={'videogames'} />
                                            <div className="checkmark"></div>
                                            <span>Juegos en línea</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt2"  {...register("pcs")} value={'s4k'} />
                                            <div className="checkmark"></div>
                                            <span>Streaming 4K</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="perfStep3GridElement">
                            <a className="mainTooltip" href='#!' onClick={() => openModalTooltip()}>
                                <i className="ico-alert-circle" />
                            </a>
                            <i className="cIco-smart-tv"></i>
                            <h4>
                                <strong>Smart TV y reproductores multimedia</strong><span> (Amazón, Fire stick, Apple tv, Chromecast, Roku y otros)</span>
                            </h4>
                            <div className="perfStep3GridEleOpt">
                                <div className="perfStep3GridEleOptCol">
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt3" {...register("smartTV")} value={'streaming'} />
                                            <div className="checkmark"></div>
                                            <span>Streaming</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt3" {...register("smartTV")} value={'s4k'} />
                                            <div className="checkmark"></div>
                                            <span>Streaming 4K</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="perfStep3GridElement">
                            <a className="mainTooltip" href='#!' onClick={() => openModalTooltip()}>
                                <i className="ico-alert-circle" />
                            </a>
                            <i className="cIco-videojuegos"></i>
                            <h4>
                                <strong>Consolas de Videojuegos</strong>
                            </h4>
                            <div className="perfStep3GridEleOpt">
                                <div className="perfStep3GridEleOptCol">
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt4" {...register("videogames")} value={'online'} />
                                            <div className="checkmark"></div>
                                            <span>Partidas Online</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt4" {...register("videogames")} value={'s4k'} />
                                            <div className="checkmark"></div>
                                            <span>Streaming 4K</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="perfStep3GridElement">
                            <a className="mainTooltip" href='#!' onClick={() => openModalTooltip()}>
                                <i className="ico-alert-circle" />
                            </a>
                            <i className="cIco-casa-inteligente"></i>
                            <h4>
                                <strong>Dispositivos inteligentes </strong><span> (Alexa, Google Home, Apple HomePod, otros</span>
                            </h4>
                            <div className="perfStep3GridEleOpt">
                                <div className="perfStep3GridEleOptCol">
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt5" {...register("devices")} value={'com'} />
                                            <div className="checkmark"></div>
                                            <span>Comunicación de Datos</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt5" {...register("devices")} value={'another'} />
                                            <div className="checkmark"></div>
                                            <span>Otra</span>
                                        </label> */}
                        {/* <div className="tooltip">
                                            <div className="tooltipC2c">
                                                <i className="ico-alert-circle"></i>
                                            </div>
                                            <span className="tooltipInfo">Claro video, Claro Play, Netflix, Youtube, otros, con calidad superior a 4K ( Alta definición 3840 x 2160 px)</span>
                                        </div> */}
                        {/* </div>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className="perfStep3GridElement">
                            <a className="mainTooltip" href='#!' onClick={() => openModalTooltip()}>
                                <i className="ico-alert-circle" />
                            </a>
                            <i className="cIco-vigilancia"></i>
                            <h4>
                                <strong>Sistemas de vigilancia</strong><span> (Cámaras, alarmas)</span>
                            </h4>
                            <div className="perfStep3GridEleOpt">
                                <div className="perfStep3GridEleOptCol">
                                    <div className="perfStep3GridElefldset">
                                        <label className="checkbox">
                                            <input type="checkbox" name="opt6" {...register("systems")} value={'live'} />
                                            <div className="checkmark"></div>
                                            <span>Transmisiones en vivo</span>
                                        </label>
                                    </div>

                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="perfiladorBtns perfBtn03">
                    {/* <Button
                        category={ButtonCategory.TRANS_GRIS}
                        onClick={()=>handleBack()}
                    >
                        Regresar
                    </Button> */}
                    <button className='btn btnTransGris' type='button' value='Perfilador2Org' onClick={handleBack}>
                        Regresar
                    </button>
                    {
                        !IsCheckAsk.filter(v => v === false)?.length
                        ?
                        <button className='btn btnPrimario' type='button' value='Perfilador4Org' onClick={(e) => { handleChangeCurrentPage(e, null, nextPage) }}>
                            Continuar
                        </button>
                        :
                        <button className='btn btnPrimario' type='button' value='Perfilador4Org' onClick={(e) => { openModalTooltip() }}>
                            Continuar
                        </button>
                    }

                    {/* <Button
                        category={ButtonCategory.PRIMARY}
                        onClick={()=>handleContinue()}
                    >
                        Continuar
                    </Button> */}
                </div>
            </form>
            <Modal
                ref={modalTooltipRef}
                size={ModalSize.SMALL}
            >
                <MTooltipModal
                    mensaje = "Debe seleccionar al menos un (1) uso de los equipos seleccionados."
                />
            </Modal>
        </>
    )
})
Perfilador3Form.propTypes = {
    onSubmit: PropTypes.func,
}

function Perfilador3PeopleOrg(props) {
    const {
        title,
        details,
        handleChangeCurrentPage,
        sections,
        activePage,
        questionsAnswers,
        handleChangeAnswerSelected,
        setContenidoSel,
        contenidoSel,
    } = props

    const onSubmitForm = data => {
        console.log('Submit:', data);
    }
    const perfiladorSteps = sections?.length ? sections.map((item, index) => (
        <li key={uuid()} className={index === activePage ? "current" : index <= activePage ? "done" : ""}>
            <span>
                <i>{index + 1}</i>
            </span>
            <strong>{item.fc_TITULO}</strong>
        </li>
    )) : null
    return (
        <section className="light">
            <div className="container">
                <div className="perfiladorTitle">
                    <h2>{title}</h2>
                    <p>{details}</p>
                </div>
                <ul className="perfiladorSteps">
                    {perfiladorSteps}
                    {/* <li className="done">
                        <span>
                            <i>1</i>
                        </span>
                        <strong>Tu Hogar</strong>
                    </li>
                    <li className="done">
                        <span>
                            <i>2</i>
                        </span>
                        <strong>Tus Dispositivos</strong>
                    </li>
                    <li className="current">
                        <span>
                            <i>3</i>
                        </span>
                        <strong>Tus Necesidades</strong>
                    </li> */}
                </ul>
                <Perfilador3Form
                    onSubmit={onSubmitForm}
                    handleChangeCurrentPage={handleChangeCurrentPage}
                    activePage={activePage}
                    nextPage={activePage + 1}
                    previousPage={activePage - 1}
                    questionsAnswers={questionsAnswers}
                    handleChangeAnswerSelected={handleChangeAnswerSelected}
                    setContenidoSel={setContenidoSel}
                    contenidoSel={contenidoSel}
                />
            </div>
        </section>
    )
}

Perfilador3PeopleOrg.defaultProps = {
    title: "Asesor de Experiencia y Velocidad Wifi",
    details: 'Con nuestro asesor de velocidad de Internet Fijo puedes calcular con mayor exactitud el plan que necesitas en tu hogar.',
}

Perfilador3PeopleOrg.propTypes = {
    title: PropTypes.string,
    details: PropTypes.string,
}

export default Perfilador3PeopleOrg
